import Axios from "api/axios"

import { store } from 'redux/storeConfig/store'

export const getProfile = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/profile'
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const updateProfile = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PATCH',
      url: '/profile',
      data: form
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const getEducations = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/educations'
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const createEducations = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/educations',
      data: form
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const updateEducations = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PATCH',
      url: '/educations',
      data: form
    })

    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const deleteEducations = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'DELETE',
      url: '/educations',
      data: form
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const getExperiences = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/experiences'
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const createExperiences = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/experiences',
      data: {
        ...form,
        endMonth: form.ongoing ? '0' : form.endMonth,
        endYear: form.ongoing ? '0' : form.endYear
      }
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const updateExperiences = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PATCH',
      url: '/experiences',
      data: form
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const deleteExperiences = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'DELETE',
      url: '/experiences',
      data: form
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const getReferences = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/references'
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const createEducationReferences = async (form) => {
  const { platform: { vp: { educations } } } = store.getState()
  const { platform: { vp: { profile: { companyReferral } } } } = store.getState()

  Object.keys(form).forEach((key) => {
    if (typeof form[key] === 'string') form[key] = form[key].trim()
  })

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/references/education',
      data: {
        ...form,
        templateId: parseInt(form.templateId),
        claims: educations[form.claimsId],
        contactType: form.noLinkedin ? 'Mobile' : 'LinkedIn',
        companyReferral
      }
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const createExperienceReferences = async (form) => {
  const { platform: { vp: { experiences } } } = store.getState()
  const { platform: { vp: { profile: { companyReferral } } } } = store.getState()

  Object.keys(form).forEach((key) => {
    if (typeof form[key] === 'string') form[key] = form[key].trim()
  })

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/references/experience',
      data: {
        ...form,
        templateId: parseInt(form.templateId),
        claims: experiences[form.claimsId],
        contactType: form.noLinkedin ? 'Mobile' : 'LinkedIn',
        companyReferral
      }
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const deleteReferences = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'DELETE',
      url: '/references',
      data: form
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}
